import(/* webpackMode: "eager", webpackExports: ["DashboardBreadcrumb"] */ "/vercel/path0/components/layout/header/dashboard-breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/vercel/path0/components/layout/header/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceSwitcher"] */ "/vercel/path0/components/layout/header/space-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/vercel/path0/components/layout/header/user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/vercel/path0/components/layout/layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/components/layout/sidebar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/vercel/path0/components/mode-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","displayName","List","Item","Trigger","Content","Link","Viewport","Indicator"] */ "/vercel/path0/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
